import 'css-chunksrc/client/scenes/editSecondaryCriteriaTemplate/styles.scss';export default {
  "header": "_header_13ufj_1",
  "group": "_group_13ufj_5",
  "text": "_text_13ufj_9",
  "name": "_name_13ufj_14",
  "main": "_main_13ufj_20",
  "buttons": "_buttons_13ufj_27"
};